import { LISTING_TYPES } from '../../constants/constants';
import Price from '../search/result/price';
import React from 'react';

export default ({ listing }) => {
  return listing.showPrice && listing.listingType === LISTING_TYPES.SALE ? (
    <span>
      {listing.isDisplayPriceSoldPrice ? 'Sold Price: ' : 'Last Asking: '}
      <Price listing={listing}/>
    </span>
  ) : null;
};


// WEBPACK FOOTER //
// ./src/components/solds/sold-price.js